import { useNavigate } from "react-router-dom";
import { HeartHandshake, Sparkles } from "lucide-react";

// 커뮤니티 중앙 — 연애 역량 진단 테스트 진입 카드 (기존 '오늘의 질문' 자리)
export const LoveTestCard = () => {
  const navigate = useNavigate();
  return (
    <div
      className="relative overflow-hidden rounded-2xl p-5 sm:p-6 mb-4 bg-gradient-to-br from-[#F7EFE7] via-[#F3EAE1] to-[#EEE1D4] border border-[#E7D8C7]"
      data-testid="love-test-card"
    >
      <div className="absolute -right-8 -top-8 w-28 h-28 rounded-full bg-burgundy-100/50 blur-2xl" />
      <div className="relative">
        <div className="flex items-center gap-1.5 mb-2">
          <Sparkles className="w-4 h-4 text-burgundy-600" />
          <span className="text-[10px] font-bold text-burgundy-700 tracking-[0.15em] uppercase">연애 역량 진단</span>
        </div>
        <h3 className="font-serif text-[20px] sm:text-[22px] font-bold bg-gradient-to-r from-burgundy-700 to-rose-500 bg-clip-text text-transparent leading-tight">
          나도 연애할 수 있을까?
        </h3>
        <p className="text-[13px] sm:text-[14px] text-stone-600 mt-2 leading-relaxed">
          나의 연애 역량을 진단하고<br className="sm:hidden" /> 나에게 꼭 맞는 실전 팁을 받아보세요.
        </p>
        <p className="text-[11.5px] text-stone-400 mt-2">총 20문항 · 약 3분 소요</p>
        <button
          onClick={() => navigate("/love-test")}
          className="mt-4 w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-3 rounded-xl bg-burgundy-600 hover:bg-burgundy-700 text-white text-[14px] font-bold shadow-sm transition-colors"
          data-testid="love-test-start-btn"
        >
          <HeartHandshake className="w-4 h-4" /> 테스트 시작하기
        </button>
      </div>
    </div>
  );
};

export default LoveTestCard;
